module.exports = __webpack_public_path__ + "static/media/p2.edd9e8ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/p2.jpg
// module id = 136
// module chunks = 0